import {IApplicationState, TBoardId} from '../../../../../../../../../types/types';

export const isAutobackupsLoading = (
    state: IApplicationState,
    boardId: TBoardId
) => {
    return state.autobackups[boardId] && state.autobackups[boardId].isLoading;
};
